import React from "react";
import { Link } from "react-router-dom";
import "./Career.css";

const jobs = [
  {
    title: "Senior React Developer",
    experience: "3+ Years",
    location: "Pune",
    description:
      "Build scalable and high-performance web applications using React and modern frontend tools.",
    requirements: [
      "Strong knowledge of React & Hooks",
      "Experience with REST APIs",
      "Good understanding of HTML, CSS, JS",
      "Problem-solving skills",
    ],
  },
  {
    title: "Python Backend Developer",
    experience: "2+ Years",
    location: "Remote",
    description:
      "Design and develop backend services using Python frameworks and databases.",
    requirements: [
      "Strong Python fundamentals",
      "Experience with Django / Flask",
      "Database knowledge (SQL/NoSQL)",
      "API development experience",
    ],
  },
  {
    title: "Java Full Stack Developer",
    experience: "2–4 Years",
    location: "Pune",
    description:
      "Develop end-to-end web applications using Java, Spring Boot and frontend technologies.",
    requirements: [
      "Java & Spring Boot",
      "Frontend basics (HTML, CSS, JS)",
      "REST API development",
      "Database understanding",
    ],
  },
  {
    title: "Web Developer",
    experience: "1–3 Years",
    location: "Pune",
    description:
      "Create responsive and visually appealing websites using modern web technologies.",
    requirements: [
      "HTML, CSS, JavaScript",
      "Responsive design",
      "Basic SEO knowledge",
      "Creative mindset",
    ],
  },
  {
    title: ".NET Developer",
    experience: "2+ Years",
    location: "Pune",
    description:
      "Build secure and scalable applications using .NET technologies.",
    requirements: [
      "C#, ASP.NET, MVC",
      "SQL Server",
      "API integration",
      "Debugging skills",
    ],
  },
  {
    title: "UI/UX Designer",
    experience: "2+ Years",
    location: "Remote",
    description:
      "Design intuitive user interfaces and enhance user experience.",
    requirements: [
      "Figma / Adobe XD",
      "Wireframing & prototyping",
      "User research",
      "Creative thinking",
    ],
  },
  {
    title: "DevOps Engineer",
    experience: "3+ Years",
    location: "Pune",
    description:
      "Maintain CI/CD pipelines and cloud infrastructure.",
    requirements: [
      "AWS / Azure",
      "Docker & Kubernetes",
      "CI/CD tools",
      "Monitoring & deployment",
    ],
  },
  {
    title: "QA Automation Engineer",
    experience: "2+ Years",
    location: "Pune",
    description:
      "Ensure software quality through automation testing.",
    requirements: [
      "Selenium / Automation tools",
      "Test case design",
      "Bug tracking",
      "Attention to detail",
    ],
  },
  {
    title: "HR Executive",
    experience: "2+ Years",
    location: "Pune",
    description:
      "Manage recruitment, employee engagement and HR operations.",
    requirements: [
      "MBA / Graduate in HR",
      "Recruitment & onboarding",
      "Communication skills",
      "HR documentation",
    ],
  },
];

function JobOpenings() {
  return (
    <div className="job-page">
      {/* Heading */}
      <div className="page-header">
        <h1>Current Job Openings</h1>
        <p className="subtitle">
          Join our growing team and build your career with us
        </p>
      </div>

      {/* Job Cards */}
      <div className="job-grid">
        {jobs.map((job, index) => (
          <div className="job-card" key={index}>
            <h2>{job.title}</h2>

            <div className="job-meta">
              <span>📍 {job.location}</span>
              <span>💼 {job.experience}</span>
            </div>

            <p className="job-desc">{job.description}</p>

            <h4>Requirements</h4>
            <ul className="req-list">
              {job.requirements.map((req, i) => (
                <li key={i}>{req}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Single Apply Button */}
      <div className="apply-section">
        <Link to="/careerform">
          <button className="apply-main-btn">Apply Now</button>
        </Link>
      </div>
    </div>
  );
}

export default JobOpenings;
